module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p10.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DISASTERS ARE GREAT EQUALIZERS.")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("They strike the rich and the poor, the sick and the healthy, the young and the old alike. But those who are wise enough to prepare or clever enough to adapt to whatever comes their way—be it blizzards and ice, hurricanes and tornadoes, earthquakes or volcanic eruptions, or heat waves and raging wildfires—will survive and thrive. You know these people: They’re the ones with a stockpile of water and nonperishable food and a battery-powered radio in their homes and an ICE (in case of emergency) card in their wallets. This book is your ticket to join these resilient ranks—to leave and breathe easier each day knowing you can handle almost any situation life throws at you. There’s no time like the present to be prepared for the future.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p12-13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p14.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("ARE YOU PREPARED FOR THE WORST?")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Natural disasters may feel like they belong in the realm of Hollywood movies or like something that seems to happen to someone else. After all, it can be uncomfortable to think about circumstances where things might be out of your control and the outcome is uncertain. But the fact is emergency situations can happen to anyone. This book isn’t intended to scare you with worst-case scenarios. It’s intended for everyday people who want to be more informed and prepared, no matter what life brings. Your willingness to increase your awareness, take steps to plan ahead, and accept that life sometimes means handling tough situations with as much calm determination you can manifest will help you be resilient and prevail.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p16-17.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a1"
    }
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("1")]), _vm._v(" AVOID A WORLD OF TROUBLE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This map shows where in the world some of the most common natural disasters occur.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("VOLCANOES")]), _vm._v(" Activity occurs largely around the Ring of Fire, the Pacific region that includes Hawaii and Japan. A second active area extends from Java all the way through the Himalayas and the Mediterranean.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EARTHQUAKES")]), _vm._v(" Most commonly occurring along the edge of the earth’s tectonic plates—sublayers of the earth that float and move—quakes also can be caused by volcanic activity, landslides, mining, fracking, and drilling.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HURRICANES")]), _vm._v(" Also known as cyclones or typhoons, these storms range widely as they are propelled by massively powerful winds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FLOODS")]), _vm._v(" While flooding can be caused by a number of factors, including dams failing or dikes being breached, in the natural world, flooding follows seasonal snowmelt and storms, and they can occur anywhere rain falls heavily.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WILDFIRES")]), _vm._v(" Not only triggered by lightning or human error, wildfires are becoming more common around the world as the climate changes and more frequent periods of drought and dry seasons increase fire risk.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TORNADOES")]), _vm._v(" Tornadoes happen when the right confluence of thunderstorms and complex air patterns come together. They devastate the central and southern United States and are common in Europe and Australia as well.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p18.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a2"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("2")]), _vm._v(" CHART YOUR PRIORITIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Knowing how to prioritize for a given disaster is important so you don’t end up focusing on the wrong thing and wasting what time you may have to prepare for your own safety. Start with the first priority and work down the list. Circumstances may change quickly; be prepared to adapt to changing conditions.")]), _vm._v(" "), _c('div', {
    staticClass: "black_level1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TSUNAMI")])])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If imminent, get to high ground immediately.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Check Internet, weather radio, or broadcast media for news in your area.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Prepare to evacuate; gather supplies and go bags.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secure your home; move valuable items to the highest floor.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Shut off utilities.")])]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('div', {
    staticClass: "black_level1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EARTHQUAKE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Get to a safe place: Drop, cover, and hold on!")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stay there until it’s safe, or leave if it’s too dangerous to stay.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Shut off utilities after the quake.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Seek shelter if your home is no longer safe.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Inventory supplies.")])]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('div', {
    staticClass: "black_level1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FLOODING")])])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Check Internet, weather radio, or broadcast media for news in your area.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Prepare to evacuate; gather supplies and go bags.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Learn the safe evacuation route if needed.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secure and sandbag your home.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Consider proactively evacuating.")])]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('div', {
    staticClass: "black_level1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TORNADO")])])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Check Internet, weather radio, or broadcast media for news in your area.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Seek cover in a shelter or an interior windowless room.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Await the all-clear signal via siren, Internet, or news.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Assess if your area is still at risk.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Evacuate to another shelter if yours is no longer sound.")])]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('div', {
    staticClass: "black_level1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HURRICANE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Check Internet, weather radio, or broadcast media for news in your area.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If time allows, board up windows; sandbag and secure your home.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gather supplies and go bags.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Decide whether to shelter in place or evacuate.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If evacuating, shut off utilities before leaving.")])]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('div', {
    staticClass: "black_level1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("VOLCANO")])])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Check Internet, weather radio, or broadcast media for news in your area.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Decide whether to shelter in place or evacuate.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gather supplies and go bags.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Wear goggles and dust masks to protect your eyes and airway.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Seal doors, windows, and ducts against ash; turn off fans and air conditioners.")])]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('div', {
    staticClass: "black_level1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WILDFIRES")])])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Check Internet, weather radio, or broadcast media for news in your area.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fill up the gas tank in the vehicle intended for evacuation.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gather supplies and go bags.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Shut off gas main; turn off propane tanks.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Consider proactively evacuating.")])]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('div', {
    staticClass: "black_level1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("POWER FAILURE")])])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Check Internet, weather radio, or broadcast media for news in your area.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Activate solar chargers or prepare portable emergency generators.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gather supplies and go bags.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Inventory supplies.")])]), _vm._v(" "), _c('div', {
    staticClass: "blue_level2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRIORITY 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "left2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ration battery-powered devices to maximize operational life.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a3"
    }
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("3")]), _vm._v(" CREATE YOUR FAMILY EMERGENCY PLAN")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the event of an emergency, a well-thought-out—and often-drilled—family emergency plan can eliminate stress, limit confusion, and save a great deal of wasted time. Instead of wondering what to do or when to do it, you can put your emergency plan to work right away, bringing sanity, calm and safety to dangerous situations.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Your emergency plan should include the following:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Up-to-date contact information cards or sheets for each family member")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Communication strategies to keep in touch with options in case the phones are out")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Self-sufficiency skills and supplies, should you have to shelter in place without utilities")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Evacuation plans and routes, should you have to leave your home")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A plan and supplies for the care of pets and livestock")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• The knowledge and tools to shut off your utilities")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Ways to assist or care for family who have mobility or medical issues, communication difficulties, or special needs")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Specialized supplies for any infants, young children, or elderly members of your family")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Learning and practicing safety skills, such as first aid, CPR, and fire prevention")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• The maintenance, inspection, and rotation of emergency supplies, such as nonperishable food, water, first aid, lighting, and communication equipment")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a4"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("4")]), _vm._v(" CONDUCT DRILLS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mark some dates on your calendar to perform emergency drills with your family. They may not want to participate, but find a way to get them involved nevertheless. Here are some emergency drills that can keep a family’s skills sharp.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DISTANT CONTACT")]), _vm._v(" Have each family member contact a friend or family member who lives outside your area—without using a phone (cell or landline). This could be done through e-mail, social media, satellite phone, ham radio, or even a carrier pigeon. Get creative!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SUPPLY SHAKEDOWN")]), _vm._v(" Pull out all your emergency supplies, take inventory, check expiration dates, use up older items, replace them with new supplies, and make sure you end up with a few more items than you started with.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FIRE DRILL")]), _vm._v(" For starters, perform a classic fire drill, evacuating the home at an unexpected time. Make sure you have a planned meeting spot outside the home, and have everyone low-crawl out of the house. For more practiced families, eliminate the easy exits and add some obstacles. Also, round out the exercise with some stop, drop, and roll each time you have a fire drill.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EVAC")]), _vm._v(" Take the fire drill exercise one step further with a mock evacuation. Tell everyone that they have two minutes to grab some clothes and supplies and get to the family vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p20.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a5"
    }
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("5")]), _vm._v(" KEEP IN CONTACT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s important that everyone in your household knows the plan for getting in touch with everyone else after a disaster. Even if you’ve loaded all the information into your mobile phones, consider also keeping a paper copy in case your phone is dead when you need the information.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Include contact information for each member of your household with full name, relation to the family, work and/or school address and phone, mobile phone, e-mail, and any other info that might be relevant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Don’t forget to include additional important information, such as date of birth, medical insurance policy numbers and phone numbers, blood type, allergies, or medical conditions. Also add names and contact information for any designated out-of-town family contacts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("List muster or evacuation points from your family plan. Review and update the information in the plan annually. Additionally, ensure all members of your household have ICE entries (see "), _c('a', {
    attrs: {
      "href": "#/cap01#a7"
    }
  }, [_vm._v("item 7")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p21.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a6"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("6")]), _vm._v(" COMMUNICATE IN A DISASTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("During a regional emergency or disaster, mobile phone systems very quickly become overloaded with voice calls. If you cannot get through, try text messaging instead, as that has a much higher chance of getting through during these types of circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you want to communicate to everyone easily with a single step, consider posting to Twitter, Facebook, or other social media with your status. Alternatively, the Red Cross offers a free Safe and Well online listing service. Just be sure to plan with other members of your household which of these systems you’ll use should you not be reachable by phone.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p21a.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a7"
    }
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("7")]), _vm._v(" BE AWARE OF ICE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In case of emergency, or ICE, is a concept that came about in 2005 when it became apparent that mobile phones were ubiquitous and were a great way to inform doctors and emergency responders whom to contact in a crisis, simply by programming extra address book entries into their cell phone, such as “ICE, dad” or “ICE, wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These days, assuming that you are carrying a smartphone, it’s a little more complicated since your screen is probably locked. However, both Android and iOS phones are able to show a list of designated emergency contacts from the lock screen if you choose to make them visible to others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other options include putting a sticker on the back of your phone or ID with your contacts. Or print out an ICE card for your wallet, purse, or glove compartment (see "), _c('a', {
    attrs: {
      "href": "#/cap01#a8"
    }
  }, [_vm._v("item 8")]), _vm._v(", next page).")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p22.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a8"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("8")]), _vm._v(" CARRY A CARD")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many insurance companies and automobile associations offer free versions of an ICE card that you can download and carry in your wallet or glove box. Or you can photocopy or scan and fill out the one provided here to make things easier for first responders and for you and your loved ones in case of an emergency.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p22a.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a9"
    }
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("9")]), _vm._v(" UNDERSTAND THE CRISIS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Being prepared for disaster means knowing the possibilities. Sometimes, a full-blown state of emergency is just a more extreme version of the minor inconveniences you’ve faced once (or many times) before.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LEVEL 1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Power outage")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aftershocks")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Volcanic ash interferes with air travel")]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LEVEL 2")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rolling brownouts")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Minor quakes")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heat and ash cause health issues")]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LEVEL 3")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Weeklong blackout")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Major quakes")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Evacuations/ local destruction of cities")]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LEVEL 4")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grid failure")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Big One")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Megavolcanic eruption")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p23.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a10"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("10")]), _vm._v(" GET FAMILIAR WITH SCOPE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With all these potential disasters, you may be wondering where to start. Let’s look at the reach of each type of crisis.")]), _vm._v(" "), _c('div', {
    staticClass: "black_level1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MINOR, SMALL-SCOPE DISASTER")])]), _vm._v(" "), _c('div', {
    staticClass: "blackleft"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Local area")])]), _vm._v(" "), _c('div', {
    staticClass: "blackleft"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A few hours to a few days")])]), _vm._v(" "), _c('div', {
    staticClass: "blackleft"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Limited services and utilities; available food and water; intact national infrastructure")])]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('div', {
    staticClass: "black_level1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MINOR, LARGE-SCOPE DISASTER")])]), _vm._v(" "), _c('div', {
    staticClass: "blackleft"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Regional area")])]), _vm._v(" "), _c('div', {
    staticClass: "blackleft"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("5–14 days")])]), _vm._v(" "), _c('div', {
    staticClass: "blackleft"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Limited services and utilities; limited amounts of food, water, and fuel; intact national infrastructure")])]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('div', {
    staticClass: "black_level1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("MAJOR DISASTER")])]), _vm._v(" "), _c('div', {
    staticClass: "blackleft"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("National area")])]), _vm._v(" "), _c('div', {
    staticClass: "blackleft"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("15–60 days")])]), _vm._v(" "), _c('div', {
    staticClass: "blackleft"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("No services and utilities; no food, water, or fuel; some disruption of national infrastructure")])]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('div', {
    staticClass: "black_level1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("GLOBAL DISASTER")])]), _vm._v(" "), _c('div', {
    staticClass: "blackleft"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Worldwide")])]), _vm._v(" "), _c('div', {
    staticClass: "blackleft"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("More than two months")])]), _vm._v(" "), _c('div', {
    staticClass: "blackleft"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("No services and utilities; no food, water, or fuel; complete collapse of government and/or financial infrastructures")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p24-25.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a11"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("11")]), _vm._v(" PACK A BOB FOR ANY SITUATION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A bug-out bag ( BOB) is a collection of goods that you would need to survive if you had to flee your home with no guarantee of shelter, food, or water during an emergency. Think of the BOB as your survival insurance policy for any disaster or mayhem. There may not be one perfect, universally agreed-upon set of equipment, but with a good core set of items (similar to those used in backpacking), you can put together a BOB suited for a wide variety of situations. Most people use either a backpack or a duffel bag as a container for their goods, which should include basic survival essentials and a few irreplaceable items. Fill up your BOB with a minimum of the things listed in the black box with most items sealed in ziplock bags to prevent damage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keep your main BOB safe and ready to go in a secure location with modified versions in your car and office. It’s also a good idea for you to have “everyday carry” (EDC) items— survival essentials that you can carry in your pocket or purse. Here’s a breakdown for these different types of kits:")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Shelter items like a small tent and sleeping bag or a tarp and blanket")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A couple quarts (or liters) of drinking water, and purification equipment to disinfect more water")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• High-calorie, no-cook foods like protein bars, peanut butter, trail mix, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• First-aid, sanitation, and hygiene supplies")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Several fire-starting devices")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A small pot for boiling water or cooking")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A few basic tools like a knife, duct tape, rope, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Extra clothes appropriate for the season")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Flashlight with extra batteries")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Cash")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A digital backup of all your important documents and artifacts. This could be a thumb drive with your bank information, insurance documents, wills, and family photos and videos")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p25a.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a12"
    }
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("12")]), _vm._v(" STOCK YOUR HOME")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chances are, we’ve all experienced a power outage at one point or another. Usually, it’s in the middle of our favorite television program or movie, and the response is one of disappointment, sometimes profane, at the interruption. The reality, however, is that most households are unprepared for losing that power for anything longer than a couple of hours. What happens if, on top of no power, the water also runs out? What are you going to do when the freezer thaws out after 24 hours without electricity? What if you have special medical needs? Are you prepared? Home survival isn’t that different from wilderness survival. The benefit is that you don’t have to carry everything you’ll need. And you also can benefit from some household hacks to turn run-of-the-mill products into life-saving materials:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/1-sky.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("WATER")]), _vm._v(" Have a weeks’ worth for you and your family (one gallon per person per day—and don’t forget about pets!). If bottled water runs out, remember there’s water in the tanks of your toilets. If you’re lucky and you have advance notice that your water supply might be jeopardized, fill up your bathtub with water so you have extra.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p26a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/2-sky.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("FOOD")]), _vm._v(" You can survive a surprisingly long time without food, so food is less of a concern. Stock up on easy dried foods to get you through the worst of it. Canned foods that don’t need heating are a good idea, as are prepackaged, high-calorie snacks. Rather than storing rice and beans in their original bags, which can rip, transfer them into 2-liter bottles for easy storing.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p26b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/3-sky.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("MEDICAL SUPPLIES")]), _vm._v(" When you’re making your at-home medical kit, think big. Spend time and a little extra cash to cover all the potential medical issues you might encounter. You also should prepare to deal with your prescription medical needs. Some medications—insulin, for example—need to be kept refrigerated.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p27.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/4-sky.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("RADIO")]), _vm._v(" A battery-powered radio is sufficient for a few days if you need to monitor emergency services (be sure you have a good supply the correct batteries on hand or it’s no use at all! In the U.S., look for a model that includes NOAA weather bands. A hand-powered radio is even better for your emergency kit. Current models also include cell-phone chargers—a potential life-saver.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p27a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/5-sky.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("CANDLES AND MATCHES")]), _vm._v(" If you’re out of candles, raid the kids’ rooms for crayons. A single crayon will burn for half an hour. Or you can put a wick in a can of vegetable shortening for a long-lasting candle.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p27b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/6-sky.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("DUCT TAPE")]), _vm._v(" You can do virtually anything with it. Really.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p27c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/7-sky.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("SHELTER AND WARMTH")]), _vm._v(" Chances are, you already have enough blankets in your house to help keep your family warm. But it’s never a bad idea to have some survival blankets as part of your emergency preparedness kit. It’s also a good idea to keep some rain tarps handy, just in case you end up with a hole in your roof or some other damage to your home that ends up exposing you to the elements.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p28.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a13"
    }
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("13")]), _vm._v(" MITIGATE HOME DISASTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Use this easy reference guide to check off the various things you can do to reduce the risk or severity of the problems you’re likely to encounter in the event of the most common natural disasters.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Keep chimneys clean, and install spark arresters.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Use truss bracing to guard against damage in high winds.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Have multiple fire extinguishers.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Install smoke detectors and carbon monoxide detectors.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Be sure circuits near sinks are properly grounded with GFI outlets.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Store plastic sheeting and duct tape to seal up the house if you need to shelter in place.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Raise heating and cooling units above the average floodline.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Strap the water heater to a wall.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Make your house number easily visible and lit for emergency vehicles to easily spot.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Install sump pump in basement.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Make sure gas lines are in good shape.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• If your area is prone to heavy freezes, insulate external pipes.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Know where shutoff valves are; attach a wrench to the pipeline so it’s there when you need it.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Don’t hide your key outside.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Install motion sensor lights.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Clear heavy vegetation that could be a fire hazard or provide cover for intruders.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Get a burglar alarm.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Check caulking and weather-stripping.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Have folding escape ladders.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Install storm shutters, or have boards for windows and sliding doors.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p29.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a14"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("14")]), _vm._v(" MAKE IT THROUGH A POWER OUTAGE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A power outage suddenly reduces your stovetop to mere counter space and makes your refrigerator no better for food storage than a pantry. But you’ve still got to eat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MIND THE EXPIRATION DATE")]), _vm._v(" Open the refrigerator door only when necessary to keep perishables and frozen food fresh. Usually food in the fridge is edible for a day, and food in the freezer for a couple of days.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("IMPROVISE A FRIDGE")]), _vm._v(" If it looks as if the power outage is going to last a few days or (gulp) a few weeks, you can store your perishable foods in camp coolers or on blocks of ice in the bathtub.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COOK SAFELY")]), _vm._v(" Never fire up a BBQ or a hibachi or start an open fire in the house. Instead, cook outdoors on a propane grill or use a Dutch oven and briquettes. If your fireplace is equipped with an iron-top inset, you can cook on that.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("APPLY THE SNIFF TEST")]), _vm._v(" Discard unsafe foods that have a foul odor, color, or texture. Even when you’re hungry, fuzz growing on the food is a bad sign.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p29a.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "a15"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("15")]), _vm._v(" KEEP IT TOGETHER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you keep your camping gear down in the basement, your disaster supplies in a closet, and your tools in your garage, you’re not unusual—but you’re also at a disadvantage in an emergency. Instead, store your tools and camping gear with your disaster supplies. You can easily grab items as you need them for, say, a camping trip or DIY project, but you won’t have to scramble for essentials in an emergency, especially if your home is partially destroyed or inaccessible. Consider buying some large sturdy plastic storage tubs, keep everything labeled and organized, and don’t forget to return anything you borrow from your stash. If you need to evacuate quickly, just grab the tubs and go.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e888b0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap01.vue
// module id = 69
// module chunks = 0